import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    checkingRestrictedAssets: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Loading toast message shown while checking for restricted assets */
            checkingRestrictedAssets: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsContext.checkingRestrictedAssets?c=10b59lta5ii23", defaultMessage: "Preparing..." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
